import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const RemoteI9Route: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      const { pathname } = window.location;
      if (!pathname.startsWith('/remote-i9')) {
        window.history.pushState(null, '', location.pathname + location.search);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [location]);

  const isLanding = location.pathname === '/remote-i9/landing';
  const isAuthRoute = location.pathname.startsWith('/remote-i9/auth/');
  const isSuccess = location.pathname === '/remote-i9/success';

  if (!isLanding && !isAuthRoute && !isSuccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};
